import { styled } from "@mui/material";

export const Section = styled('section')(({ theme }) => (props) => ({
    padding: '24px 0px 24px 96px  ',
    [theme.breakpoints.down('md')]: {
        padding: '24px 0px 24px 48px  '
    },
    [theme.breakpoints.down('sm')]: {
        padding: '12px 0px 12px 24px  '
    },
    [theme.breakpoints.down('xs')]: {
        padding: '6px 0px 6px 12px  '
    },
    borderBottom: '1px Solid #E0E0E0',
}))
export const ContentSlider = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    overflowY: 'hidden',
    overflowX: 'auto',
    padding: '15px 0px ',
    [theme.breakpoints.down('md')]: {
        padding: '12px 0'
    },
}))

export const Card = styled('div')(({ theme }) => (props) => ({
    minWidth: '288px',
    height: '400px',
    textAlign: 'left',
    minHeight: '350px',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('lg')]: {
        height: '400px',
    },
    [theme.breakpoints.down('md')]: {
        height: '300px',
        minWidth: "200px",
        minHeight: '290px',
    },

}))
export const ImageCard = styled('div')(({ theme }) => (props) => ({
    maxWidth: '288px',
    maxHeight: '248px',
    minWidth: '288px',
    minHeight: '248px',
    height: '248px',
    width: '288px',
    borderRadius: '5px',
    [theme.breakpoints.down('md')]: {
        minWidth: "200px",
        minHeight: '190px',
    }
}))
export const Image = styled('img')(({ theme }) => (props) => ({
    width: '100%',
    height: '100%',
    borderRadius: '5px'
}))
export const TitleHeading = styled('h4')(({ theme }) => (props) => ({
    fontSize: '1.5vw',
    fontWeight: '700',
    lineHeight: '1.8vw',
    margin: '0 ',
    padding: ' 16px 5px  5px 5px',
    width: '90%',
    height: '100px',
    color: theme.palette.mode === 'light' ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
    [theme.breakpoints.up('lg')]: {
        fontSize: '24px'
    },
    [theme.breakpoints.down('md')]: {
        fontSize: '1.7vw'
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '18px',
        lineHeight: '20px'
    }

}))
export const TitleRaeteng = styled('p')(({ theme }) => (props) => ({
    fontSize: '12px',
    fontWeight: '300',
    lineHeight: '0',
    letterSpacing: '0em',
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.mode === "light" ? theme.palette.text.light : theme.palette.text.dark,
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.2vw'
    },
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.3vw'

    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '10px',
    }
}))

export const TextDiscretion = styled('p')(({ theme }) => (props) => ({
    fontSize: '1vw',
    fontWeight: '400',
    lineHeight: '1.6vw',
    letterSpacing: '0em',
    display: 'block',
    color: theme.palette.mode === "light" ? theme.palette.text.light : theme.palette.text.dark,
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.2vw'
    },
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.3vw',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '12px',
        fontWeight: '600'
    }
}))